import { render, staticRenderFns } from "./ConfirmDeleteCriteriaModal.vue?vue&type=template&id=d592312a&"
import script from "./ConfirmDeleteCriteriaModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteCriteriaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports